import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { Step } from 'primeng/stepper';

const Common = definePreset(Aura, {
    components: {
        button: {
            colorScheme: {
                light: {
                    root: {
                        danger: {
                            background: '{red.600}'
                        },
                        contrast: {
                            background: '#fe8761',
                            hoverBackground: '#de572c',
                            focusBackground: '#de572c',
                            activeBackground: '#de572c',
                            borderColor: '#fff',
                            hoverBorderColor: '#fff',
                            activeBorderColor: '#fff'
                        },
                    },
                    outlined: {
                        contrast: {
                            borderColor: '#de572c',
                            color: '#de572c',
                            hoverBackground: '#de572c1c',
                        }
                    }
                },
            }
        },
        stepper: {
            stepTitle: {
                activeColor: '#de572c'
            },
            stepNumber: {
                activeColor: '#de572c'
            }
        },
        checkbox: {
            root: {
                width: '2rem',
                height: '2rem'
            }
        }
        
    },
    global: {
        fontFamily: `'Circe', sans-serif`
    },
    semantic: {
        // primary: {
        //     50: "#f4f5f9",     // Couleur très claire, presque blanche
        //     100: "#cbcfe1",     // Clair avec une légère touche de bleu-gris
        //     200: "#a3a8c9",     // Bleu-gris moyen
        //     300: "#7a82b2",     // Bleu plus saturé et légèrement plus foncé
        //     400: "#515b9a",     // Bleu plus profond
        //     500: "#283582",     // Couleur de base (bleu foncé)
        //     600: "#222d6f",     // Un bleu plus sombre
        //     700: "#1c255b",     // Bleu très foncé
        //     800: "#161d48",     // Bleu presque noir
        //     900: "#101534",     // Bleu très très foncé, presque noir
        //     950: "#0a0d21"      // Bleu extrême, presque noir
        // },
        colorScheme: {
            light: {
                // surface: {
                //     0: '#ffffff',
                //     50: '{zinc.50}',
                //     100: '{zinc.100}',
                //     200: '{zinc.200}',
                //     300: '{zinc.300}',
                //     400: '{zinc.400}',
                //     500: '{zinc.500}',
                //     600: '{zinc.600}',
                //     700: '{zinc.700}',
                //     800: '{zinc.800}',
                //     900: '{zinc.900}',
                //     950: '{zinc.950}'
                // }
            },
            dark: {
                // surface: {
                //     0: '#ffffff',
                //     50: '{slate.50}',
                //     100: '{slate.100}',
                //     200: '{slate.200}',
                //     300: '{slate.300}',
                //     400: '{slate.400}',
                //     500: '{slate.500}',
                //     600: '{slate.600}',
                //     700: '{slate.700}',
                //     800: '{slate.800}',
                //     900: '{slate.900}',
                //     950: '{slate.950}'
                // }
            }
        }
    }
});

export default Common;